module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_M5-4b30c57b24d59b039f122b5f23f5257e.png";